import React from 'react';
import { useLoaderData } from 'react-router-dom';

import Location from '@r6digital/rapidstor-types/react/entities/Location';

import classes from './Navbar.module.scss';

import Logo from '../assets/logo.png';
import BackLink from './BackLink';
import JourneyProgress from './JourneyProgress';
import JourneySelectors from './JourneySelectors';

interface Props {
    label: string;
    hideSelectors?: boolean;
    storageTypeSelect?: boolean;
    finalPage?: boolean;
    setCurrentPersonaId?: (id: string | null) => void;
}

function Navbar({
    label,
    storageTypeSelect,
    setCurrentPersonaId,
    hideSelectors,
    finalPage,
}: Props) {
    const location = useLoaderData() as Location;

    return (
        <>
            <div className={`${classes.yellow_bar}`}>
                {location ? <BackLink className={`${classes.backlink}`} /> : <div></div>}
                <img src={Logo} />
                {location ? (
                    <a href={`tel:${location.contactPhone}`}>
                        <svg
                            width='18'
                            height='18'
                            viewBox='0 0 18 18'
                            fill='none'
                            xmlns='http://www.w3.org/2000/svg'
                        >
                            <mask id='path-1-inside-1_1703_26' fill='white'>
                                <path
                                    fillRule='evenodd'
                                    clipRule='evenodd'
                                    d='M13.1225 17.7471C11.8607 17.7007 8.28465 17.2065 4.53947 13.4622C0.795167 9.71698 0.301827 6.1418 0.254508 4.87909C0.184407 2.9548 1.65829 1.08572 3.36089 0.355786C3.56591 0.267253 3.79043 0.233546 4.01242 0.257972C4.2344 0.282398 4.44622 0.364118 4.6271 0.495112C6.02913 1.51684 6.99653 3.06258 7.82723 4.27797C8.01001 4.54499 8.08816 4.86993 8.04679 5.19086C8.00542 5.5118 7.84742 5.80629 7.60291 6.01824L5.89331 7.28796C5.81071 7.3476 5.75257 7.43519 5.72968 7.53447C5.7068 7.63375 5.72073 7.73796 5.76887 7.82774C6.15619 8.53138 6.84493 9.5794 7.63358 10.368C8.4231 11.1567 9.52019 11.891 10.2729 12.3221C10.3673 12.3751 10.4784 12.3899 10.5833 12.3635C10.6883 12.3371 10.7791 12.2715 10.8372 12.1802L11.9501 10.4863C12.1547 10.2146 12.4565 10.0325 12.7923 9.97826C13.1282 9.92404 13.472 10.0019 13.7517 10.1954C14.9846 11.0489 16.4234 11.9997 17.4767 13.3482C17.6183 13.5304 17.7084 13.7473 17.7376 13.9762C17.7667 14.2051 17.7338 14.4377 17.6423 14.6495C16.9089 16.3609 15.053 17.8181 13.1225 17.7471Z'
                                />
                            </mask>
                            <path
                                fillRule='evenodd'
                                clipRule='evenodd'
                                d='M13.1225 17.7471C11.8607 17.7007 8.28465 17.2065 4.53947 13.4622C0.795167 9.71698 0.301827 6.1418 0.254508 4.87909C0.184407 2.9548 1.65829 1.08572 3.36089 0.355786C3.56591 0.267253 3.79043 0.233546 4.01242 0.257972C4.2344 0.282398 4.44622 0.364118 4.6271 0.495112C6.02913 1.51684 6.99653 3.06258 7.82723 4.27797C8.01001 4.54499 8.08816 4.86993 8.04679 5.19086C8.00542 5.5118 7.84742 5.80629 7.60291 6.01824L5.89331 7.28796C5.81071 7.3476 5.75257 7.43519 5.72968 7.53447C5.7068 7.63375 5.72073 7.73796 5.76887 7.82774C6.15619 8.53138 6.84493 9.5794 7.63358 10.368C8.4231 11.1567 9.52019 11.891 10.2729 12.3221C10.3673 12.3751 10.4784 12.3899 10.5833 12.3635C10.6883 12.3371 10.7791 12.2715 10.8372 12.1802L11.9501 10.4863C12.1547 10.2146 12.4565 10.0325 12.7923 9.97826C13.1282 9.92404 13.472 10.0019 13.7517 10.1954C14.9846 11.0489 16.4234 11.9997 17.4767 13.3482C17.6183 13.5304 17.7084 13.7473 17.7376 13.9762C17.7667 14.2051 17.7338 14.4377 17.6423 14.6495C16.9089 16.3609 15.053 17.8181 13.1225 17.7471Z'
                                stroke='#242424'
                                strokeWidth='3'
                                mask='url(#path-1-inside-1_1703_26)'
                            />
                        </svg>
                    </a>
                ) : (
                    <div></div>
                )}
            </div>
            <JourneyProgress />
            <div className={`${finalPage ? classes.final_page : classes.regular}`}>
                <div className={`${classes.navbar}`}>
                    <div className={`${classes.container}`}>
                        <BackLink className={`${classes.backlink}`} />
                        <div className={`${classes.backlinkWS}`}>&nbsp;</div>
                        <span className={`${classes.label}`}>{label}</span>
                        <div>&nbsp;</div>
                    </div>
                </div>
                {location && (
                    <JourneySelectors
                        hideSelectors={hideSelectors}
                        storageTypeSelect={storageTypeSelect}
                        setCurrentPersonaId={setCurrentPersonaId}
                    />
                )}
            </div>
        </>
    );
}

export default Navbar;
